import {Fragment} from 'react';
import {Link} from 'react-router';

function Menuloop({ADMINMENUITEMS, toggleSidemenu, level}: any) {
  return (
    <Fragment>
      <Link
        to="#!"
        className={`side-menu__item ${ADMINMENUITEMS?.selected ? 'active' : ''}`}
        onClick={event => {
          event.preventDefault();
          toggleSidemenu(event, ADMINMENUITEMS);
        }}
      >
        {ADMINMENUITEMS.icon}
        <span className={`${level == 1 ? 'side-menu__label' : ''}`}>
          {ADMINMENUITEMS.title}
          {ADMINMENUITEMS.badgetxt ? <span className={ADMINMENUITEMS.class}>{ADMINMENUITEMS.badgetxt}</span> : ''}
        </span>
        <i className="fe fe-chevron-right side-menu__angle"></i>
      </Link>
      <ul
        className={`slide-menu child${level} ${ADMINMENUITEMS.active ? 'double-menu-active' : ''} `}
        style={ADMINMENUITEMS.active ? {display: 'block'} : {display: 'none'}}
      >
        {level <= 1 ? (
          <li className="slide side-menu__label1">
            <Link to="#">{ADMINMENUITEMS.title}</Link>
          </li>
        ) : (
          ''
        )}
        {ADMINMENUITEMS.children.map((firstlevel: any) => (
          <li
            className={`${firstlevel.menutitle ? 'slide__category' : ''} ${firstlevel?.type == 'empty' ? 'slide' : ''} ${firstlevel?.type == 'link' ? 'slide' : ''} ${firstlevel?.type == 'sub' ? 'slide has-sub' : ''} ${firstlevel?.active ? 'open' : ''} ${firstlevel?.selected ? 'active' : ''}`}
            key={Math.random()}
          >
            {firstlevel.type === 'link' ? (
              <Link to={firstlevel.path + '/'} className={`side-menu__item ${firstlevel.selected ? 'active' : ''}`}>
                {firstlevel.icon}
                <span className="">
                  {firstlevel.title}
                  {firstlevel.badgetxt ? <span className={firstlevel.class}>{firstlevel.badgetxt}</span> : ''}
                </span>
              </Link>
            ) : (
              ''
            )}
            {firstlevel.type === 'empty' ? (
              <Link to="#" className="side-menu__item">
                {firstlevel.icon}
                <span className="">
                  {firstlevel.title}
                  {firstlevel.badgetxt ? <span className={firstlevel.class}>{firstlevel.badgetxt}</span> : ''}
                </span>
              </Link>
            ) : (
              ''
            )}
            {firstlevel.type === 'sub' ? (
              <Menuloop ADMINMENUITEMS={firstlevel} toggleSidemenu={toggleSidemenu} level={level + 1} />
            ) : (
              ''
            )}
          </li>
        ))}
      </ul>
    </Fragment>
  );
}

export default Menuloop;
